import LiveClock from 'components/common/LiveClock';
import AddGropus from 'components/permissionGroup/AddGroup';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { PermissionSelector } from 'slices/permissionGroupSlice';
import { fetchPermissionGroupList } from 'slices/permissionGroupSlice';
import { templatesSelector } from 'slices/templateSlice';
import { fetchTemplatesListPage } from 'slices/templateSlice';

const UpdateGroup = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { permissionList, loader, error } = useSelector(PermissionSelector);
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchPermissionGroupList());
    }, [dispatch]);

    if (!permissionList?.length) return <div>Loading...</div>;

    const item = permissionList?.find(t => t.id === Number(id));
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Permission Group</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            {item ? <AddGropus item={item} loader={loader}/> : <div>Item not found</div>}
        </div>
    );
};

export default UpdateGroup;
